import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/cat-app/cat-app/app/components/NavBar.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/cat-app/cat-app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/cat-app/cat-app/app/providers/ReactQueryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/cat-app/cat-app/node_modules/@anu-its/ts-react-components/dist/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["Header","Footer"] */ "/home/runner/work/cat-app/cat-app/node_modules/@anu-its/ts-react-components/dist/index.esm.js");
